import * as React from 'react';
// import classNames from 'classnames';
import { assign as _assign } from 'lodash';
import Slider from 'rc-slider';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import {  
  BuiltInPartsDefaultModel, 
  BuiltInPartsModel, 
  ConfigurationDefaultModel, 
  ConfigurationModel, 
  CUT_OUT_CUSTOM, MinMaxModel, getMinFromArrayOfNumbers, dimensions, 
  // getMinFromArrayOfNumbers 
} from 'franke-trough-dependencies';
import { DebounceInput } from 'react-debounce-input';
import { requestAPIActions } from 'loopback-react-request';
import { filter as _filter } from 'lodash';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './Recesses.messages';
// import MSG from './Recesses.messages';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface CutOutDisposalCustomProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  defaults: GlobalPrivateState['configurationDefaults'];
}

export interface CutOutDisposalCustomState {
  type: CUT_OUT_CUSTOM | null;
  width: number;
  depth: number;
}

export class CutOutDisposalCustomPartial extends React.Component<CutOutDisposalCustomProps, CutOutDisposalCustomState> {
  constructor(props: CutOutDisposalCustomProps) {
    super(props);
    this.state = {
      type: null,
      width: this.rangeDefaults.min,
      depth: this.rangeDefaults.min
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSlide = this.handleSlide.bind(this);
    this.handleSlideAfterChange = this.handleSlideAfterChange.bind(this);
  }

  updateState() { 
    // Why does it break if no timeout... agh... so confused...
    // It's like the the setState calls below have no impact at all otherwise
    setTimeout(() => {
      const disposalType = this.builtInParts && this.builtInParts.cutOutDisposalsType;

      if (disposalType) {
        const newType = disposalType === 'CUSTOM_ROUND' ? 'round' : 'square';

        if (this.state.type !== newType) {
          this.setState({
            ...this.state,
            type: newType
          });
        }
      }

      const disposalSettings = this.builtInParts && this.builtInParts.cutOutDisposalsCustomSettings;

      if (disposalSettings) {
        if (typeof disposalSettings.width !== 'undefined' && this.state.width !== disposalSettings.width) {
          this.setState({
            ...this.state,
            width: disposalSettings.width
          });
        }

        if (typeof disposalSettings.depth !== 'undefined' && this.state.depth !== disposalSettings.depth) {
          this.setState({
            ...this.state,
            depth: disposalSettings.depth
          });
        }
      }
    }, 1);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps: CutOutDisposalCustomProps) {
    const prevConfiguration = prevProps.configuration.result;

    if (
      (this.configuration && prevConfiguration) && 
      (this.configuration.updated_at !== prevConfiguration.updated_at)  
    ) {
      this.updateState();
    }
  }

  public render() {
    const defaultMark: number = this.state.type === 'round' ? 135 : 162;
    const defaultMarks: any = {[defaultMark]: defaultMark};
		
    return this.builtInParts && this.builtInPartsDefaults ? (
      <div className="partial-cutout-custom">
        <div className="row mb-4">
          {this.state.type && (
            <>
              <div className={classNames({'col-12': this.state.type === 'round', 'col-6': this.state.type === 'square'})}>
                <div className="form-group position-relative">
                  <div className="col-12 mt-2 px-0">
                    <label className="small mb-2 mt-2 p-0 d-block">
                      {this.state.type === 'round' && (
                        <FormattedMessage {...MESSAGES.cutOutLabelCustomInputDiameter} />
                      )}
                      {this.state.type === 'square' && (
                        <FormattedMessage {...MESSAGES.cutOutLabelCustomInputWidth} /> 
                      )}
                    </label>
                    <DebounceInput
                      className="form-control"
                      disabled={this.disabled}
                      max={this.rangeDefaults.max}
                      min={this.rangeDefaults.min}
                      type="number" 
                      value={this.state.width}
                      onChange={(ev: React.SyntheticEvent<HTMLInputElement>) => this.handleInputChange(ev, 'width')}
                      debounceTimeout={1000}
                    />
                  </div>
                  <div className="col-12 mt-4 px-0">
                    <div className="form-slider">
                      <span>{this.rangeDefaults.min}</span>
                      <Slider
                        disabled={this.disabled}
                        min={this.rangeDefaults.min}
                        max={this.rangeDefaults.max}
                        step={0.5}
                        value={this.state.width}
                        onChange={(val: number) => this.handleSlide(val, 'width')}
                        onAfterChange={this.handleSlideAfterChange}
                        marks={this.rangeDefaults.max < defaultMark ? {} : defaultMarks}
                      />
                      <span>{this.rangeDefaults.max}</span>
                    </div>
                  </div>
                
                </div>
              </div>
              {this.state.type === 'square' && (
                <div className="col-6">
                  <div className="form-group position-relative">
                      <div className="col-12 mt-2 px-0">
                        <label className="small mb-2 mt-2 p-0 d-block">
                          <FormattedMessage {...MESSAGES.cutOutLabelCustomInputDepth} />
                        </label>
                        <DebounceInput
                          className="form-control"
                          disabled={this.disabled}
                          min={this.rangeDefaults.min}
                          max={this.rangeDefaults.max}
                          type="number" 
                          value={this.state.depth}
                          onChange={(ev: React.SyntheticEvent<HTMLInputElement>) => this.handleInputChange(ev, 'depth')}
                          debounceTimeout={1000}
                        />
                      </div>
                      <div className="col-12 mt-4 px-0">
                        <div className="form-slider">
                          <span>{this.rangeDefaults.min}</span>
                          <Slider
                            disabled={this.disabled}
                            min={this.rangeDefaults.min}
                            max={this.rangeDefaults.max}
                            step={0.5}
                            value={this.state.depth}
                            onChange={(val: number) => this.handleSlide(val, 'depth')}
                            marks={defaultMarks}
                            onAfterChange={this.handleSlideAfterChange}
                          />
                          <span>{this.rangeDefaults.max}</span>
                        </div>
                      </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    ) : null;
  }

  private get builtInParts(): BuiltInPartsModel | undefined | null {
    return this.configuration && this.configuration.builtInParts;
  }

  private get builtInPartsDefaults(): BuiltInPartsDefaultModel | undefined {
    return this.defaults && this.defaults.builtInParts;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }

  private get defaults(): ConfigurationDefaultModel | undefined {
    return this.configuration && this.configuration.defaults || this.props.defaults.result;
  }

  private get disabled(): boolean {
    const hasPlaced = this.configuration && this.configuration.builtInParts && this.configuration.builtInParts.cutOutDisposalsPosition  && this.configuration.builtInParts.cutOutDisposalsPosition.includes(true) || false;
		return !isConfigurationEditable() || !this.configuration || !this.configuration.builtInParts || hasPlaced;
  }

  private dispatchConfiguration(props: CutOutDisposalCustomState) {
    // if (this.disabled) { return; }


    // Don't dispatch if values outside of min/max range
    let errors = false;
    if (props.hasOwnProperty('width')) {
      if (props.width < this.rangeWidth.min || props.width > this.rangeWidth.max) {
        errors = true;
      }
    }

    if (!errors) {
      const builtInParts: BuiltInPartsModel = ((this.configuration as ConfigurationModel).builtInParts as BuiltInPartsModel);
      if (!props.type) { return; }

      builtInParts.cutOutDisposalsCustomSettings = {
        width: props.width,
        depth: props.type === 'round' ? props.width : props.depth
      }

      this.props.dispatch(requestAPIActions.load(
        'configuration', {
          url: `/Configurations/${this.configuration && this.configuration.id}`,
          options: {
            method: 'PATCH',
            data: {builtInParts: builtInParts}
          },
        },
        true,
      ));
    }
  }

  private handleInputChange(ev: React.SyntheticEvent<HTMLInputElement>, type: string) {
    const target = ev.target as HTMLInputElement;
    const value = Math.round(Number(target.value)); // This caused issue where things didnt post up
    const state: CutOutDisposalCustomState = this.state;

    if (typeof state[type] !== 'undefined' && state[type] !== value) {
      state[type] = value;
      this.setState(state);
      this.dispatchConfiguration(state);
    }
  }

  private handleSlide(val: number, type: string) {
    const state: CutOutDisposalCustomState = this.state;
    const value = val; // Math.round(Number(val)); // Rounding caused issue where things didnt post up
    
    if (typeof state[type] !== 'undefined' && state[type] !== value) {
      this.setState({
        ...this.state,
        [type]: value
      });
      // this.dispatchConfiguration(state);
    }
  }

  private handleSlideAfterChange() {
    const state: CutOutDisposalCustomState = this.state;
    this.dispatchConfiguration(state);
  }

  private get rangeDefaults(): MinMaxModel {
    const defaultRange: MinMaxModel = {
      max: 300,
      min: 10,
    };

    return defaultRange;
  }

  private get rangeWidth(): MinMaxModel {
    const defaultRange = this.rangeDefaults;

    if (!this.builtInPartsDefaults || !this.builtInPartsDefaults.cutOutDisposalsPosition) {
      return defaultRange;
    }

    const spacings = this.builtInPartsDefaults.cutOutDisposalsPosition.spacings;
    const positions = this.builtInParts && this.builtInParts.cutOutDisposalsPosition || [];
    const usedSpacings = spacings.filter((spacing, i) => positions[i]);
    const spacing = getMinFromArrayOfNumbers(usedSpacings) - dimensions.techSpecs.individualRecessBuffer.round;

    // Is this going to work? I think getting min doesn't work...
    // I think I may still have to go with selected position index? Otherwise how do I know how big they 
    // Ah... what I do is first just let them completely control the size of the cut-out and then show positions after it

    return {
      max: spacing > defaultRange.max ? defaultRange.max : spacing,
      min: defaultRange.min,
    };
  }
}

export const CutOutDisposalCustom = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  defaults: state.configurationDefaults,
}))(CutOutDisposalCustomPartial);
